import { cn } from "@/lib/utils";
import { TruncatedTooltip } from "@/components/ui/truncated-tooltip";

interface InfoItemProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  className?: string;
  cssLabel?: string;
}

export function InfoItem({ icon, label, value, className, cssLabel }: InfoItemProps) {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <div className="flex h-10 w-10 items-center justify-center rounded bg-[#EBEBEB] text-[#000000] shrink-0">
        {icon}
      </div>
      <div className={cn("flex flex-col gap-0.5", cssLabel)}>
        <span className="text-sm text-[#000000] whitespace-nowrap">{label}</span>
        <TruncatedTooltip className="text-sm text-[#000000] shrink-0 truncate">
          {value}
        </TruncatedTooltip>
      </div>
    </div>
  );
}

interface InfoRowProps {
  label: string;
  value: string;
  isLast?: boolean;
}

export function InfoRow({ label, value, isLast = false }: InfoRowProps) {
  return (
    <div
      className={`flex items-baseline gap-2 py-2 ${isLast ? "" : "border-b border-black/[0.09]"}`}
    >
      <span className="w-16 shrink-0 text-sm text-[#646464]">{label}</span>
      <span className="flex-1 text-right text-sm text-[#202020] truncate">{value}</span>
    </div>
  );
}
